class Car {
  constructor(
    id,
    make,
    model,
    variant,
    version,
    vin,
    productionYear,
    fuel,
    engineCapacity,
    enginePowerKw,
    curbWeight,
    firstRegistrationDate,
    carNickname,
    color,
    ownerId,
    registrationNumber,
    ownershipId,
    finished,
    image,
    mileageEntry,
  ) {
    this.id = id;
    this.make = make;
    this.model = model;
    this.variant = variant;
    this.version = version;
    this.vin = vin;
    this.productionYear = productionYear;
    this.fuel = fuel;
    this.engineCapacity = engineCapacity;
    this.enginePowerKw = enginePowerKw;
    this.curbWeight = curbWeight;
    this.firstRegistrationDate = firstRegistrationDate;
    this.carNickname = carNickname;
    this.color = color;
    this.ownerId = ownerId;
    this.registrationNumber = registrationNumber;
    this.ownershipId = ownershipId;
    this.finished = finished;
    this.image = image;
    this.mileageEntry = mileageEntry;
  }
}

export default Car;
